import { ChevronRightIcon } from '@heroicons/react/24/outline';
import React from 'react';

import type { HomePage } from '~/interfaces/home_page';

interface BreadcrumbsProps {
  breadcrumbs: { text: string; href?: string | undefined }[];
  homePage?: HomePage;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs, homePage }) => {
  const color = homePage?.general_section.theme.text_color || '';

  return (
    <ul className="flex flex-wrap items-center gap-2 text-xs font-semibold">
      {breadcrumbs.map((item, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: Keeping this for backwards compatibility
        <React.Fragment key={index}>
          <li
            suppressHydrationWarning
            className="flex items-center gap-2 text-wt-text-on-background"
            style={{ color: color }}
          >
            {index === breadcrumbs.length - 1 ? (
              <span className="!opacity-100">{item.text}</span>
            ) : (
              <React.Fragment>
                {item.href ? (
                  <a href={item.href} className="opacity-70">
                    {item.text}
                  </a>
                ) : (
                  <span className="opacity-70">{item?.text}</span>
                )}
              </React.Fragment>
            )}
            {index !== breadcrumbs.length - 1 && <ChevronRightIcon height="14px" />}
          </li>
        </React.Fragment>
      ))}
    </ul>
  );
};

export default Breadcrumbs;
